import { theme } from '@itv/mui-for-itv';

const colours = theme.palette;

export { colours };
export default colours;
